import { motion } from "framer-motion";
import React, { useEffect } from "react";
import { MdBatchPrediction } from "react-icons/md";
import QdtComponentPredictions from "../../components/QdtComponentPredictions";
import { qdtComponents } from "../../config/predictionsAppConfig";
import { useApp } from "../../context/AppContext";
import { fadeIn } from "../../util/animation";

export default function Predictions() {
  const { goToTop, clearAllSelections } = useApp();

  useEffect(() => {
    goToTop();
  }, [goToTop]);

  async function ClearSelections() {
    clearAllSelections();
    const qApp = await qdtComponents.qAppPromise;
    qApp?.clearAll();
  }

  return (
    <motion.div variants={fadeIn} initial="hidden" animate="show">
      <section className="section-space bg-predictions-img bg-overlay">
        <div className="container">
          <div className="row rowsafari">
            <div className="col-lg-12">
              <div className="row">
                <MdBatchPrediction color={"white"} size={54} />
                <div className="section-width mt-2">
                  <h2 className="text-light">Predictions</h2>
                  <h6 className="theme-color-1 section-grp-margin-bottom text-light">
                    Who will make it to the Top 10?
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="container section-space about position-relative section-gray-bg"
        id="about"
      >
        <div className="container">
          <div className="row rowsafari">
            <div className="col-lg-6 res-desk-mar-bot">
              <h6 className="section-grp-margin-bottom theme-color-1">
                Predictions
              </h6>
              <h3 className="section-margin-bottom">
                Who will make it <br />
                to the Top 10?
              </h3>
              <p>
                The list shows the players with the highest probability of
                making to the Top 10. <br />
                This is a static list generated before the tournament begins.
              </p>
            </div>
            <div className="col-lg-6 text-end">
              <button
                onClick={() => ClearSelections()}
                className="btn btn-warning text-success mb-3"
              >
                Clear Selections
              </button>
              <div className="border border-success rounded bg-white p-2 shadow">
                <QdtComponentPredictions
                  type="QdtViz"
                  props={{
                    id: "NAjYqU",
                    height: "320px",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-space section-white-bg">
        <div className="container">
          <div className="section-width">
            <h2 className="mb-3">How did we do it?</h2>
            <h6 className="theme-color-1 section-grp-margin-bottom">
              IPC Global used 17 years of PGA data to train a Machine Learning
              model to predict the Top 10 players for the 2025 Masters. The data
              was prepared and aggregated in Qlik Sense and fed to Qlik AutoML.
              The model selected to make 2025 predictions was a Random Forest
              Classifier.
            </h6>
          </div>
          <div className="row">
            <QdtComponentPredictions
              type="QdtViz"
              props={{
                id: "nmmSuX",
                height: "180px",
              }}
            />
          </div>
        </div>
      </section>

      <section className="container section-space section-gray-bg">
        <div className="container">
          <div className="section-width">
            <h2 className="mb-3">ROC & SHAP</h2>
            <h6 className="theme-color-1 section-grp-margin-bottom">
              The ROC Curve shows the result of accuracy test for the selected
              classifier. The SHAP Importance chart shows the features with the
              highest prediction impact.
            </h6>
          </div>
          <div className="row">
            <div className="col-lg-6 col-sm-12 res-desk-mar-bot">
              <div className="border border-success rounded">
                <QdtComponentPredictions
                  type="QdtViz"
                  props={{
                    id: "XTQTWpY",
                    height: "550px",
                  }}
                />
              </div>
            </div>
            <div className="col-lg-6 colsm-12">
              <div className="border border-success rounded">
                <QdtComponentPredictions
                  type="QdtViz"
                  props={{
                    id: "HxzqqR",
                    height: "550px",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="container section-space bg-predictions-models-img bg-overlay">
        <div className="container">
          <div className="row rowsafari">
            <div className="col-lg-8">
              <h3 className="section-margin-bottom text-white">
                Who should you select for your Pools?
              </h3>
            </div>
            <div className="col-lg-4">
              <h5 className="text-white">
                Based on the model's prediction, these are the players IPC
                Global recommends for the Pool selection.
              </h5>
            </div>
          </div>
        </div>
      </section>
      <section className="container section-space section-gray-bg">
        <div className="container">
          <div className="row rowsafari">
            <div className="col-lg-3 col-md-6 col-sm-6 col-6">
              <div className="card shadow">
                <div className="card-body">
                  <QdtComponentPredictions
                    type="QdtViz"
                    props={{
                      id: "JkyDvV",
                      height: "120px",
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-6 mb-1 mb-sm-4">
              <div className="card shadow">
                <div className="card-body">
                  <QdtComponentPredictions
                    type="QdtViz"
                    props={{
                      id: "sUVZtm",
                      height: "120px",
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-6">
              <div className="card shadow">
                <div className="card-body">
                  <QdtComponentPredictions
                    type="QdtViz"
                    props={{
                      id: "KqJbWX",
                      height: "120px",
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-6">
              <div className="card shadow">
                <div className="card-body">
                  <QdtComponentPredictions
                    type="QdtViz"
                    props={{
                      id: "VTYguJ",
                      height: "120px",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="container section-space section-white-bg">
        <div className="container">
          <div className="section-width">
            <h3>Predictions - Full List</h3>
          </div>
          <div className="row">
            <div className="border border-success rounded">
              <QdtComponentPredictions
                type="QdtViz"
                props={{
                  id: "ghCYz",
                  height: "350px",
                }}
              />
            </div>
          </div>
        </div>
      </section>
    </motion.div>
  );
}
